import React from 'react';
import { X, ArrowLeftRight, Check } from 'lucide-react';
import { founderData, calculateCompatibility } from '../utils/mockData';
import { LinkedInIcon } from './LinkedInIcon';
interface MatchesModalProps {
  onClose: () => void;
}
interface FounderMatch {
  founder1: string;
  founder2: string;
  compatibility: number;
  reasons: string[];
}
export const MatchesModal = ({
  onClose
}: MatchesModalProps) => {
  // Top matches data
  const topMatches: FounderMatch[] = [{
    founder1: '13',
    founder2: '25',
    compatibility: 96,
    reasons: ['Both Harvard alums with complementary technical backgrounds', "Divanny's Splunk scaling experience pairs with Eric's Modal infrastructure", 'Shared big tech experience (Google/Splunk) and startup exits', "Eric's technical depth complements Divanny's product/UX strengths"]
  }, {
    founder1: '7',
    founder2: '23',
    compatibility: 94,
    reasons: ["Tommy's revenue scaling expertise ($200M ARR) complements Vicki's infrastructure mastery", 'Both SF-based with early-founder experience', 'Complementary skills in GTM and systems architecture', 'Shared focus on productivity tools and AI scaling']
  }, {
    founder1: '3',
    founder2: '6',
    compatibility: 92,
    reasons: ['Strong CEO/CTO archetype balance', 'Complementary skills in health tech and consumer marketplaces', 'Both have experience scaling large organizations', 'Shared MBA background creates strong network effect']
  }, {
    founder1: '4',
    founder2: '6',
    compatibility: 90,
    reasons: ['Enterprise sales expertise pairs with operational excellence', 'Complementary Fintech and Marketplace experience', 'Similar execution velocity and work style', 'Both have previous exits and scaling experience']
  }, {
    founder1: '5',
    founder2: '1',
    compatibility: 93,
    reasons: ['Combined AI expertise (Databricks Mosaic, Scale AI, YouTube discovery)', 'Both SF-based with strong academic backgrounds (MIT/Stanford)', 'Shared focus on healthcare/ML applications', "Vijay's MBA bridges Tejas' product focus for a balanced team"]
  }, {
    founder1: '2',
    founder2: '9',
    compatibility: 91,
    reasons: ["Nidhi's PE/VC experience complements Kevin's engineering expertise", 'SF-based with global mindsets and complementary skills', "Nidhi's ventures/BD background pairs with Kevin's technical infrastructure knowledge", 'Shared interest in emerging technologies and fintech applications']
  }];
  return <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50" data-id="element-502">
      <div className="bg-[#111] border border-[#222] rounded-lg w-[800px] max-h-[80vh] flex flex-col" data-id="element-503">
        <div className="flex justify-between items-center p-4 border-b border-[#222]" data-id="element-504">
          <h2 className="text-lg font-semibold text-white" data-id="element-505">
            Top Founder Matches
          </h2>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-[#222] text-gray-400 hover:text-white" data-id="element-506">
            <X size={20} data-id="element-507" />
          </button>
        </div>
        <div className="overflow-y-auto p-4 flex-1" data-id="element-508">
          <div className="space-y-6" data-id="element-509">
            {topMatches.map((match, index) => {
            const founder1 = founderData.find(f => f.id === match.founder1);
            const founder2 = founderData.find(f => f.id === match.founder2);
            if (!founder1 || !founder2) return null;
            return <div key={index} className="p-4 rounded-lg border border-purple-500/30 bg-[#1a1a1a]" data-id="element-510">
                  <div className="flex justify-between items-center mb-3" data-id="element-511">
                    <div className="flex items-center" data-id="element-512">
                      <div className="flex items-center" data-id="element-513">
                        <div className="w-10 h-10 rounded-full overflow-hidden mr-2" data-id="element-514">
                          {founder1.photoUrl ? <img src={founder1.photoUrl} alt={founder1.name} className="w-full h-full object-cover" data-id="element-515" /> : <div className={`w-full h-full flex items-center justify-center ${founder1.archetype === 'CEO' ? 'bg-purple-500' : 'bg-green-500'}`} data-id="element-516">
                              <span className="text-white font-bold" data-id="element-517">
                                {founder1.name.split(' ').map(n => n[0]).join('')}
                              </span>
                            </div>}
                        </div>
                        <div data-id="element-518">
                          <div className="flex items-center" data-id="element-519">
                            <p className="font-semibold" data-id="element-520">{founder1.name}</p>
                            {founder1.linkedinUrl && <a href={founder1.linkedinUrl} target="_blank" rel="noopener noreferrer" className="ml-2 text-blue-400 hover:text-blue-300" data-id="element-521">
                                <LinkedInIcon size={12} data-id="element-522" />
                              </a>}
                          </div>
                          <p className="text-xs text-gray-400" data-id="element-523">
                            {founder1.archetype}
                          </p>
                        </div>
                      </div>
                      <ArrowLeftRight size={16} className="mx-3 text-gray-500" data-id="element-524" />
                      <div className="flex items-center" data-id="element-525">
                        <div className="w-10 h-10 rounded-full overflow-hidden mr-2" data-id="element-526">
                          {founder2.photoUrl ? <img src={founder2.photoUrl} alt={founder2.name} className="w-full h-full object-cover" data-id="element-527" /> : <div className={`w-full h-full flex items-center justify-center ${founder2.archetype === 'CEO' ? 'bg-purple-500' : 'bg-green-500'}`} data-id="element-528">
                              <span className="text-white font-bold" data-id="element-529">
                                {founder2.name.split(' ').map(n => n[0]).join('')}
                              </span>
                            </div>}
                        </div>
                        <div data-id="element-530">
                          <div className="flex items-center" data-id="element-531">
                            <p className="font-semibold" data-id="element-532">{founder2.name}</p>
                            {founder2.linkedinUrl && <a href={founder2.linkedinUrl} target="_blank" rel="noopener noreferrer" className="ml-2 text-blue-400 hover:text-blue-300" data-id="element-533">
                                <LinkedInIcon size={12} data-id="element-534" />
                              </a>}
                          </div>
                          <p className="text-xs text-gray-400" data-id="element-535">
                            {founder2.archetype}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center" data-id="element-536">
                      <div className={`text-xl font-bold ${getScoreColor(match.compatibility)}`} data-id="element-537">
                        {match.compatibility}%
                      </div>
                    </div>
                  </div>
                  <div className="mt-3" data-id="element-538">
                    <p className="text-xs text-gray-400 mb-2" data-id="element-539">
                      Why they match:
                    </p>
                    <div className="space-y-1.5" data-id="element-540">
                      {match.reasons.map((reason, i) => <div key={i} className="flex items-start" data-id="element-541">
                          <Check size={14} className="text-green-400 mt-0.5 mr-2 flex-shrink-0" data-id="element-542" />
                          <p className="text-xs text-gray-300" data-id="element-543">{reason}</p>
                        </div>)}
                    </div>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </div>;
};
// Helper function to get color based on score
const getScoreColor = (score: number): string => {
  if (score >= 90) return 'text-green-400';
  if (score >= 80) return 'text-green-500';
  if (score >= 70) return 'text-yellow-400';
  if (score >= 60) return 'text-orange-400';
  return 'text-red-400';
};